import React,{Fragment} from "react";
import {Link} from 'react-router-dom';
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextStepButton from "../../partials/NextStepButton";

/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm, setStep } from "../../../store/actions/FormAction";
/*
    Importing Footer from partials folder
*/
import Footer from '../../partials/Footer';
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

/*
    Checking all fields filled properly
    States are async so was not immediate response that I needed
*/
function checkAll(emailchecked,passwordchecked) {
    if (emailchecked === true && passwordchecked === true){
      return true;
    }
    return false;
}

/*
    CreateAccount view that displays the Create Account page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class CreateAccount extends React.Component {
  constructor(props){
    super(props);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);

    this.emailchecked = false;
    this.passwordchecked = false;
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Login");
    this.props.setStep(0);

    //TODO: need to grab email from API
    // email from state
    if (validation.validateEmail(this.props.eml)) {
      this.emailchecked = true;
      document.querySelector("label[for='eml']").classList.add("active");
      document.querySelector("label[for='pwd']").focus();
    }
    // password from state
    if (this.props.pwd.length >= 8 && validation.validatePass(this.props.pwd)) {
      this.passwordchecked = true;
      document.querySelector("label[for='pwd']").classList.add("activepass");
      document.querySelector("label[for='econsent']").focus();
    }
  }

  handleEmailChange(e) {
    let email = e.target.value;
    this.props.updateForm("eml", email);

    const emaillabel = document.querySelector("label[for='eml']");
    if (validation.validateEmail(email)) {
      this.emailchecked = true;
      emaillabel.classList.add("active");
    } else {
      this.emailchecked = false;
      emaillabel.classList.remove("active");
    }
    this.props.updateForm("allchecked", checkAll(this.emailchecked,this.passwordchecked,this.econsentchecked));
  }

  handlePasswordChange(e) {
    let password = e.target.value;
    this.props.updateForm("pwd", password);

    const passlabel = document.querySelector("label[for='pwd']");
    if (password.length >= 8 && validation.validatePass(password)) {
      this.passwordchecked = true;
      passlabel.classList.add("activepass");
    } else {
      this.passwordchecked = false;
      passlabel.classList.remove("activepass");
    }

    this.props.updateForm("allchecked", checkAll(this.emailchecked,this.passwordchecked));
  }

  handleEyeClick(e){
    e.preventDefault();
    var x = document.getElementById("pwd");
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
  }

  render() {

    const nextStep = 1;
    const nextLink = "/dashboard/myaccount";
    const btnText = "Log Me In";
    const btnClasses = "btn next-step";

    return (
      <Fragment>
        <div className="container" id="stepper-step-2">
            <div className="text-center topcopy">
              <img src="/images/logo/logo.png" className="toplogo" alt="MoneyKey logo"/>
              <h1>Welcome Back!</h1>
              <h5>To login, please enter your details.</h5>
            </div>
            <hr />
            <form className="flowform">
                <input type="hidden" value="needed for disabling autocomplete" />
                <div className="form-group">
                    <label htmlFor="eml" >
                        Email
                        <input type="email" name="eml" id="eml" autoComplete="eml" className="form-control" tabIndex="1" value={this.props.eml} onChange={this.handleEmailChange} /> <div className="nothuman"><input type="email" name="email" /></div>
                    </label>
                    <p className="already">Don&#39;t have an account yet? <Link to="/">Get Started</Link></p>
                </div>
                <div className="form-group">
                    <label htmlFor="pwd">
                        Password
                        <input type="password" name="pwd" id="pwd" autoComplete="pwd" className="form-control" tabIndex="2" value={this.props.pwd} onChange={this.handlePasswordChange} />
                        <a className="allseeing" onClick={this.handleEyeClick} >
                          <svg width="20px" viewBox="0 0 20 13">
                              <g stroke="none" strokeWidth="1" transform="translate(-260.000000, -406.000000) translate(260.000000, 406.000000)" fill="#7F868A" fillRule="nonzero">
                                  <path d="M10.0001136,0 C5.21617662,0 1.19200936,2.75570577 0,6.5 C1.19200936,10.2445411 5.21640376,13 9.99988643,13 C14.7838234,13 18.8079906,10.2442942 20,6.5 C18.8079906,2.75545893 14.7838234,0 10.0001136,0 Z M10.0755227,11.0924315 C7.70240651,11.0924315 5.77879232,9.00195572 5.77879232,6.42298637 C5.77879232,3.84401701 7.70240651,1.75354118 10.0755227,1.75354118 C12.4484118,1.75354118 14.3722531,3.84401701 14.3722531,6.42298637 C14.3722531,9.00195572 12.4484118,11.0924315 10.0755227,11.0924315 Z" id="Shape"></path>
                              </g>
                          </svg>
                        </a> <div className="nothuman"><input type="password" name="password" /></div>
                    </label>
                </div>

                <NextStepButton next={nextLink} btnText={btnText} btnClasses={btnClasses} step={nextStep} tabIndex="3"/>

            </form>
        </div>
        <Footer />
      </Fragment>
      );
    }
}


const mapStateToProps = (state) => ({
    eml: state.FormReducer.eml,
    pwd: state.FormReducer.pwd,
    econsent: state.FormReducer.econsent,
    allchecked: state.FormReducer.allchecked
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount)



// WEBPACK FOOTER //
// ./src/components/views/Login/index.js